import React from 'react';
import AddAboutUs from '../../pages/adminpanelpages/AddAboutUs';
import AddAddress from '../../pages/adminpanelpages/AddAdress';
import AddPhone from '../../pages/adminpanelpages/AddPhone';
import AddProject from '../../pages/adminpanelpages/AddProject';
import AddressList from '../../pages/adminpanelpages/AddressList';
import AddService from '../../pages/adminpanelpages/AddService';
import PhoneList from '../../pages/adminpanelpages/PhoneList';
import ProjectList from '../../pages/adminpanelpages/ProjectList';
import ServiceList from '../../pages/adminpanelpages/ServicesList';

function MainContent({ activeItem }: { activeItem: string | null }) {
  const menuItems = [
    { id: 'add-phone', label: 'Telefon Ekle' },
    { id: 'our-phones', label: 'Telefonlarım' },
    { id: 'add-address', label: 'Adres ekle' },
    { id: 'our-address', label: 'Adreslerim' },
    { id: 'add-about', label: 'Hakkımızda Ekle' },
    { id: 'add-project', label: 'Proje Ekle' },
    { id: 'our-projects', label: 'Projelerimiz' },
    { id: 'add-service', label: 'Hizmet Ekle' },
    { id: 'our-services', label: 'Hizmetlerimiz' },
  ];

  const activeLabel = menuItems.find((item) => item.id === activeItem)?.label || 'HOŞGELDİNİZ';

  // Her `id` için özel içerik tanımlayın
  const renderContent = () => {
    switch (activeItem) {
      case 'add-phone':
        return (
          <div>
            <AddPhone />
          </div>
        );

      case 'our-phones':
        return (
          <div>
            <PhoneList />
          </div>
        );

      case 'add-address':
        return (
          <div>
            <AddAddress />
          </div>
        );

        case 'our-address':
        return (
          <div>
            <AddressList />
          </div>
        );

        case 'add-about':
          return (
            <div>
              <AddAboutUs />
            </div>
          );
          case 'add-project':
          return (
            <div>
              <AddProject />
            </div>
          );
          case 'our-projects':
          return (
            <div>
              <ProjectList />
            </div>
          );
          case 'add-service':
          return (
            <div>
              <AddService />
            </div>
          );
          case 'our-services':
          return (
            <div>
              <ServiceList />
            </div>
          );

      default:
        return <p>Yönetim paneline hoş geldiniz! Soldaki menüden dilediğiniz işlemi seçebilirsiniz.</p>;
    }
  };

  return (
    <div className="flex-grow p-6 bg-gray-100" id="main-content">
      <h1 className="text-2xl font-bold mb-4">{activeLabel}</h1>
      <div className="bg-white rounded-lg shadow-md p-6">{renderContent()}</div>
    </div>
  );
}

export default MainContent;
